import { Suspense, ElementType } from 'react';
import LoadingScreen from 'components/LoadingScreen';

export const Loadable = (Component: ElementType) => (props: any) => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
};

export type IncludeAuth = (auth: string[]) => boolean;
